module.exports = __webpack_public_path__ + "static/media/videoSign.0126d2e5.svg";